<mat-card appearance="outlined" class="syn-card" *ngIf="projectRoles?.length" [style.padding]="'0.7em'">

    <mat-form-field class="filter" appearance="outline">
        <mat-label>Filtrer</mat-label>
        <input
            #filter
            matInput
            type="text"
            (keyup)="applyFilter(filter.value)"
            placeholder="Filtrer"
        />
        <button
            mat-icon-button
            matSuffix
            (click)="applyFilter('', filter)"
        >
            <mat-icon svgIcon="close"></mat-icon>
        </button>
    </mat-form-field>

    <mat-table #table [dataSource]="dataSource" matSort matSortActive="userInfos" matSortDirection="asc">

        <!-- user -->
        <ng-container matColumnDef="fullName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                Utilisateur
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <syn-user-avatar
                    *ngIf="row.user"
                    [user]="row.user"
                    [showLegend]="true"
                    [caption]="row.user.id"
                ></syn-user-avatar>
            </mat-cell>
        </ng-container>

        <!-- company -->
        <ng-container matColumnDef="company">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                Société
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <syn-company-avatar
                    *ngIf="row.user && row.user.company && companies[row.user.company]"
                    [company]="companies[row.user.company]"
                    [showLegend]="true"
                    [size]="24"
                ></syn-company-avatar>
            </mat-cell>
        </ng-container>

        <!-- 24/7 -->
        <ng-container matColumnDef="247">
            <mat-header-cell *matHeaderCellDef>
                9h-18h ou 24/7
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                {{ row.user?.is247 ? '24/7' : '9h-18h' }}
            </mat-cell>
        </ng-container>

        <!-- roles -->
        <ng-container matColumnDef="roles">
            <mat-header-cell *matHeaderCellDef  mat-sort-header>
                Rôles
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <div class="syn-flexrow syn-flexrow--fluid">

                    <div>
                        <mat-chip-listbox>
                            <mat-chip disableRipple *ngFor="let chip of row.roles">
                                {{ chip }}
                            </mat-chip>
                        </mat-chip-listbox>
                    </div>

                    <div class="syn-flexrow__cell--minwidth">
                        <button mat-icon-button (click)="displayAclsInformation(row)" color="primary">
                            <mat-icon svgIcon="information-outline"></mat-icon>
                        </button>
                    </div>

                </div>
            </mat-cell>
        </ng-container>

        <!-- MSO -->
        <ng-container matColumnDef="mso">
            <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                matTooltip="Envoi d'un email pour information lors d'un Major Service Outage, incident majeur impactant plusieurs clients."
            >
                MSO
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <syn-in-array [needle]="'MSO'" [stack]="row.communicationTypes"></syn-in-array>
            </mat-cell>
        </ng-container>

        <!-- INCIDENT -->
        <ng-container matColumnDef="incident">
            <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                matTooltip="Envoi d'un email pour information lors de la déclaration d'un incident sur le projet."
            >
                INCIDENT
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <syn-in-array [needle]="'INCIDENT'" [stack]="row.communicationTypes"></syn-in-array>
            </mat-cell>
        </ng-container>

        <!-- REQUEST -->
        <ng-container matColumnDef="request">
            <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                matTooltip="Envoi d'un email pour information lors de la création d'une demande sur le projet."
            >
                REQUEST
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <syn-in-array [needle]="'REQUEST'" [stack]="row.communicationTypes"></syn-in-array>
            </mat-cell>
        </ng-container>

        <!-- PATCH -->
        <ng-container matColumnDef="patch">
            <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                matTooltip="Envoi d'un email pour information du patch management."
            >
                PATCH
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <syn-in-array [needle]="'PATCH'" [stack]="row.communicationTypes"></syn-in-array>
            </mat-cell>
        </ng-container>

        <!-- CHANGE -->
        <ng-container matColumnDef="change">
            <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                matTooltip="Envoi d'un email pour information lors d'une intervention planifiée."
            >
                CHANGE
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <syn-in-array [needle]="'CHANGE'" [stack]="row.communicationTypes"></syn-in-array>
            </mat-cell>
        </ng-container>

         <!-- BILLING -->
         <ng-container matColumnDef="billing">
            <mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                matTooltip="Envoi d'un email pour information concernant la partie finance."
            >
                BILLING
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
                <syn-in-array [needle]="'BILLING'" [stack]="row.communicationTypes"></syn-in-array>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <mat-paginator
        *ngIf="showPaginator"
        #paginator
        [length]="projectRoles?.length"
        [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
    ></mat-paginator>

</mat-card>
